<template>
  <div v-if="plate">
    <v-checkbox
      :label="`${lead.firstname}, I want to make sure we're on the same page.
       You NEED Life Insurance to: Take care of ${selectedNeeds}, you want to make sure
        ${beneficiary.name} could survive`"
      v-model="plate.isMainNeedsAsked"
      :error="$v.plate.isMainNeedsAsked.$error"
    />

    <v-checkbox
      :label="`I know ${beneficiary.name} is ${beneficiary.status}: ${beneficiary.relationship}`"
      v-model="plate.isBeneficiaryAsked"
      :error="$v.plate.isBeneficiaryAsked.$error"
    />

    <div v-for="(need, k) in needsList" :key="k">
      <v-checkbox
        v-bind="needDetails(need)"
        v-model="plate[needDetails(need).model]"
      />
    </div>

    <v-checkbox
      label="You'd like to pin-up a safety-net so that if anything
        happens, your loved ones are financially protected, so they can focus on you
        and your memory and not have to struggle. Do I have that right?"
      v-model="plate.isProtectedAsked"
      :error="$v.plate.isProtectedAsked.$error"
    />

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps, ProtectionTypes } from '@/common/variables';
import { isChecked } from '@/common/helpers';

export default {
  name: 'NeedsPlate',
  components: { PlateFooter },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ needs: 'plates/needs' }),
    selectedNeeds() {
      const filteredKeys = Object.keys(this.needs).filter(
        (i) => this.needs[i].isSelected
      );

      return filteredKeys
        .map((key) => this.needs[key].label)
        .toString()
        .replaceAll(',', ', ');
    },
    needsList() {
      return Object.keys(this.needs).filter((k) => this.needs[k].isSelected);
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.needs
    );
    this.plate = data;
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.analysis);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.process);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
    needDetails(type) {
      const protection = this.needs[type];

      switch (type) {
        case ProtectionTypes.debt:
          return {
            model: 'isDebtProtection',
            error: this.$v.plate.isDebtProtection.$error,
            label: `We DO need Debit protection, to avoid the reassigning
              of debits or collections. You have ${protection.amount} you'd like covered.`,
          };

        case ProtectionTypes.mortgage:
          return {
            model: 'isMortgageProtection',
            error: this.$v.plate.isMortgageProtection.$error,
            label: `We do need mortgage protection, to make sure they'll have a
              roof over their head. You have ${protection.amount} left on the house
              with roughly ${protection.yearsLeft} years`,
          };

        case ProtectionTypes.family: {
          const collegeText = `${protection.collegeExpenses ? 'Is' : 'Isn`t'}
           important to take care of college expenses`;

          const childrenText = `${
            protection.isAnyChildren
              ? `${protection.childrenCount} young ones, the youngest being
              ${protection.childrenAge} years old and it ${collegeText}`
              : ''
          }`;

          return {
            model: 'isFamilyProtection',
            error: this.$v.plate.isFamilyProtection.$error,
            label: `We ${protection.replacement ? 'Do' : 'Don`t'} need income
              replacement, to supplement the loss earning they would experience.
              You ${protection.isAnyChildren ? 'Do' : 'Don`t'} have children.
              ${childrenText}`,
          };
        }

        case ProtectionTypes.finalExpenses: {
          const relationText =
            this.beneficiary.relationship === 'spouse'
              ? `I know ${this.beneficiary.name} is a ${this.beneficiary.status}. We
                want them to focus on your memory.`
              : `I know ${this.beneficiary.name} gave you ${
                  //Todo check ability to change beni data if lead not DISABLED
                  this.beneficiary.grandchildrenAmount
                }
                and ${this.beneficiary.liveInSameState ? "won't" : 'will'}
                have to travel from out of town. We want them to focus on you and
                your memory.`;

          return {
            model: 'isFinalExpenses',
            error: this.$v.plate.isFinalExpenses.$error,
            label: `${this.lead.firstname}, you want to make sure ${this.beneficiary.name}
              doesn't have to come out of pocket for the ${protection.target}. ${relationText}`,
          };
        }

        default:
          return '';
      }
    },
  },
  validations: {
    plate: {
      isMainNeedsAsked: { checked: isChecked },
      isBeneficiaryAsked: { checked: isChecked },
      isProtectedAsked: { checked: isChecked },
      isFamilyProtection: {
        checked: function (val) {
          if (this.needs[ProtectionTypes.family].isSelected)
            return isChecked(val);
          return true;
        },
      },
      isMortgageProtection: {
        checked: function (val) {
          if (this.needs[ProtectionTypes.mortgage].isSelected)
            return isChecked(val);
          return true;
        },
      },
      isDebtProtection: {
        checked: function (val) {
          if (this.needs[ProtectionTypes.debt].isSelected)
            return isChecked(val);
          return true;
        },
      },
      isFinalExpenses: {
        checked: function (val) {
          if (this.needs[ProtectionTypes.finalExpenses].isSelected)
            return isChecked(val);
          return true;
        },
      },
    },
  },
};
</script>

<style scoped></style>